module.exports = __webpack_public_path__ + "img/menu3-3.eca03e1d.jpg";